import { useTranslation } from "react-i18next";
import { Button, Col, Form, FormInstance, Row } from "antd";
import { FormLayout } from "antd/es/form/Form";
import { Store } from "antd/es/form/interface";
import React from "react";
import { SharedSpinner } from "../SharedSpinner";

interface Props {
  children?: any;
  loading?: boolean;
  form: FormInstance<any>;
  layout?: FormLayout;
  initial?: Store | undefined;
  onReset?: () => void;
  onFinish?: (values: any) => Promise<void>;
  showReset?: boolean;
}

export const SharedForm: React.FC<Props> = ({
  form,
  children,
  loading = false,
  layout = "vertical",
  initial,
  onReset,
  onFinish,
  showReset = true,
}) => {
  const { t } = useTranslation();
  return (
    <SharedSpinner loading={loading}>
      <Form
        form={form}
        layout={layout}
        initialValues={initial}
        onFinish={onFinish}
        onReset={onReset}
      >
        {children}
        <Form.Item>
          <Row
            justify="end"
            gutter={6}
            style={{ marginBottom: -30, marginTop: -10 }}
          >
            {showReset && (
              <Col>
                <Button htmlType="reset">{t("CloseButton")}</Button>
              </Col>
            )}
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading}
                loading={loading}
              >
                {t("SaveButton")}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </SharedSpinner>
  );
};
